import { colorService } from '@logz-pkg/utils';
import { colors } from '../../../../../components/themes';

export const graphLightV2Theme = {
  gridLineColor: colors.royalBlue[100],
  labelColor: colors.royalBlue[900],
  lineColor: colors.gray[800],
  crosshairColor: colors.gray[900],
  barCrosshairColor: colorService.convertHexToRgba('#E6EAEC', 0.6),
  oppositeYAxisLineColor: colors.gray[1000],
  oppositeYAxisLabelColor: '#09A2C3',
  markerOnHoverColor: colors.gray[1000],
  eventActionMenuCardBorderColor: colors.blue[400],
  eventActionMenuCardTextColor: colors.gray[1000],
  eventActionMenuCardButtonTextColor: colors.royalBlue[1000],
  eventActionMenuCardIconColor: colors.royalBlue[1000],
};
